import { Form } from 'antd';
import { type FormProviderProps } from 'antd/es/form/context';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { authActions } from '@store/auth/auth.slice';

import { RouteEnum } from '@enum/route.enum';
import { useLoginMutation } from '@hook/auth/auth.hooks';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useStoreDispatch, useStoreSelector } from '@hook/store/store.hooks';
import { LoginRequestInterface } from '@interface/auth/login.interface';

export const useLogin = () => {
  const dispatch = useStoreDispatch();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { action } = useMutation(useLoginMutation(), authActions, authActions.setData);
  const { error, isLoading } = useStoreSelector((state) => state.auth);

  const onLogin: FormProviderProps['onFormFinish'] = async (_, { values }) => {
    try {
      await action(values as LoginRequestInterface);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      // Error is already handled by the useMutation hook and stored in Redux state
      // The FormError component will display the error from the Redux state
      // We just need to prevent the unhandled promise rejection
      return;
    }
  };

  const onSignUpPage = useCallback(() => {
    dispatch(authActions.resetErrors());
    form.resetFields();
    navigate(RouteEnum.SignUp.path);
  }, [dispatch, form, navigate]);

  return {
    error,
    isLoading,
    form,
    onLogin,
    onSignUpPage,
  };
};
